import moment from "moment";

import { DataQueryBase } from "../../types/dataQueries/base/DataQueryBase";


const constantQueries = {
  fetch: {
    Sorts: []
  },
  fetchPaged: {
    Take: 10,
    Skip: 0,
    Sorts: []
  }
}

export const getConstantQueryFetch: <T>() => DataQueryBase<T> = () => constantQueries.fetch;
export const getConstantQueryFetchPaged: <T>() => DataQueryBase<T> = () => constantQueries.fetchPaged;

export const constantFormat = {
  DateToString: (x: Date): string => moment(x).format("DD.MM.YYYY"),
  DateTimeToString: (x: Date | undefined): string => x ? moment(x).format("DD.MM.YYYY HH:mm") : '',
  StringToDate: (x: string): Date => typeof x === `string` ? new Date(x) : x as Date,
  calendar: `dd.mm.yy`,
}

export const constantSearchParams = {
  Tab: `Tab`,
  PageOffset: `pageOffset`,
  Node: `nodeId`,
}

export const commonConstant = {
  appName: `Автоматизация процесса согласования ТЗ, ПД, РД `,
  appNameShort: `Автоматизация процесса согласования ТЗ, ПД, РД `,
  companyName: `X5 Retail Group`,
  calendar: {
    firstDayOfWeek: 1,
    dayNames: [
      `Воскресенье`,
      `Понедельник`,
      `Вторник`,
      `Среда`,
      `Четверг`,
      `Пятница`,
      `Суббота`,
    ],
    dayNamesShort: [`Воск`, `Пон`, `Вт`, `Ср`, `Четв`, `Пят`, `Суб`],
    dayNamesMin: [`Вс`, `Пн`, `Вт`, `Ср`, `Чт`, `Пт`, `Сб`],
    monthNames: [
      `Январь`,
      `Февраль`,
      `Март`,
      `Апрель`,
      `Май`,
      `Июнь`,
      `Июль`,
      `Август`,
      `Сентябрь`,
      `Октябрь`,
      `Ноябрь`,
      `Декабрь`,
    ],
    monthNamesShort: [
      `Янв`,
      `Фев`,
      `Мар`,
      `Апр`,
      `Май`,
      `Июн`,
      `Июл`,
      `Авг`,
      `Сен`,
      `Окт`,
      `Ноя`,
      `Дек`,
    ],
    today: `Сегодня`,
    clear: `Очистить`,
    dateFormat: `dd.mm.yy`,
  },
}

export const constantTable = {
  initialPagedList: { Items: [], TotalCount: 0, Skipped: 0 },
  paginatorRows: 10,
  searchRows: 10,
  // paginatorTemplate: `CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown`,
  currentPageReportTemplate: `Показано с {first} по {last} из {totalRecords}`,
  paginatorTemplate: `CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink`,
  paginatorRowOptions: [10, 20, 50, 100],
  emptyMessage: `Нет данных для отображения`,
}

export const constantMessage = {
  unAuthorizedMessage: `Проверка авторизации...`,
  cancelRequest: `Operation canceled due user action`,
  noPermissionMessage: `Нет доступа`
}